export default __webpack_public_path__ + "static/media/Бор_20л.e83f1531.jpg";